import { useCallback } from 'react';
import { Tab } from '../Tab';

export interface TabItemProps {
  label: string;
  badgeNumber?: number;
}

interface TabsProps {
  activeTab: number;
  tabs: Array<TabItemProps>;
  onTabChange?: (tabNumber: number) => void;
  variant?: 'primary' | 'secondary';
}

export const Tabs = ({ activeTab, tabs, onTabChange, variant }: TabsProps) => {
  const handleTabClick = useCallback(
    (tabNumber: number) => () => {
      onTabChange?.(tabNumber);
    },
    [onTabChange],
  );

  return (
    <div className="flex flex-row gap-1.25">
      {tabs.map((tab, index) => (
        <Tab
          key={tab.label}
          badgeNumber={tab.badgeNumber}
          active={activeTab === index}
          onClick={handleTabClick(index)}
          variant={variant}
        >
          {tab.label}
        </Tab>
      ))}
    </div>
  );
};
